// Copyright (c) 2016 Deere & Company

export const buildClassName = (targetCompletion, completePercentage) =>
    completePercentage >= targetCompletion ? 'dot-icon-green' : 'dot-icon-red';



// WEBPACK FOOTER //
// ./src/pip/shared/services/build-class-name.js